$(document).ready(function() {
	$('.home-testimonial__items').on('init', function(event, slick){
		$('.home-testimonial__items.slick-initialized').css({'opacity': '1', 'visibility': 'visible'});
	});

	$('.home-testimonial__items').slick({
		dots: false,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		autoplay: true
	});
});